import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name components.component:al-pdf-viewer
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="components">
 <file name="index.html">
 <al-pdf-viewer data=""></al-pdf-viewer>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.components')
    .component('alPdfViewer', {
        bindings: {
            data: '='
        },
        controller: 'PdfViewerComponentController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/al-pdf-viewer/component.js